import React, { Component } from 'react';
import { AvField } from 'availity-reactstrap-validation';
import i18n from '../../i18next';

class TableMinute extends Component {
    render() {
        let validateMinutes = /\b^([0-5][0-9]|[0-9])\b/;

        return (
            <div>
                <AvField
                    type={this.props.type}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    style={this.props.customStyle}
                    disabled={this.props.disabled}
                    id={this.props.id}
                    step={this.props.step}
                    value={this.props.value}
                    onChange={this.props.handleStateChange}
                    onBlur={this.props.handleBlur}
                    onKeyPress={this.props.onKeyPress}
                    validate={{
                        pattern: {
                            value: validateMinutes,
                            errorMessage: i18n.t('common:validations.invalidMinute')
                        }
                    }}
                    errorMessage={i18n.t('common:validations.invalidMinute')}
                    invalid={(this.props.invalid) ? this.props.invalid : false}
                    day={this.props.day}
                />
            </div>
        );
    }
}

export default TableMinute;


// WEBPACK FOOTER //
// ./src/components/common/TableMinute.js